















































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { getQuestionCart, updateQuestionCart } from '../model/api'

@Component
export default class QuestionBus extends Vue {
  public data = [1]
  public list = []
  public clickWhere = ''
  public questions = []
  public status: boolean = false
  public showDetail(val: boolean) {
    this.status = !val
  }
  // computed
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get count() {
    return this.cartInfo && this.cartInfo.question_ids ? this.cartInfo.question_ids.length : 0
  }
  public get user() {
    return this.$store.state.user_info
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  public get moduleName() {
    return this.$route.meta.name
  }
  @Watch('cartInfo', { deep: true })
  onInfoChange(data) {
    console.log(data.question_ids.length)
    if (!data) {
      return
    }
    this.processCart(data)
  }
  @Watch('user', { deep: true })
  onUserChange(val) {
    if (val && val.name) {
      this.getCart()
      if (this.clickWhere === 'preview') {
        this.goPreview()
      }
    } else {
    }
  }
  @Watch('subjectId')
  onSubjectChange(val, old) {
    if (val !== old) {
      this.getCart()
    }
  }
  // mounted
  public mounted() {
    setTimeout(() => {
      this.getCart()
    }, 500)
  }
  // methods
  public goPreview() {
    window['sensors'].track('TIKU_preview_content', {
      buttonName: '预览',
      proSource: this.moduleName,
      content: '试题',
      paper_subject: this.$store.state.subject.label
    })
    if (this.user && this.user.nickname) {
      if (this.cartInfo && this.cartInfo.question_ids.length) {
        setTimeout(() => {
          window.open('/question/preview', '_blank')
        }, 200)
      }
    } else {
      this.clickWhere = 'preview'
      this.$store.commit('SET_LOGINMODAL', true)
    }
  }
  public processCart(data) {
    let temp: any = []
    temp = data.classification
    this.list = temp
    this.questions = data.question_ids
  }
  public async getCart() {
    if (!this.subjectId) return
    let temp: any = []
    let data: any = await getQuestionCart({ subject_id: this.subjectId })
    // console.log(data)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
      this.processCart(data.data)
    } else {
      if (data.error === '请登录') {
        this.$store.commit('SET_CART', { classification: {}, question_ids: [], title: '' })
      }
    }
  }
  public onDeleteBtnClick(item) {
    this.$confirm({
      okText: '确定',
      title: '确定要删除该题型下所有试题吗？',
      content: (h) => {
        return h('div', {}, '（删除后，试题将无法找回）')
      },
      maskClosable: false,
      keyboard: false,
      onOk: () => {
        this.clearAll(item)
      }
    })
  }
  public onClearAllBtnClick() {
    this.$confirm({
      okText: '确定',
      title: '确定要清空全部试题吗？',
      content: (h) => {
        return h('div', {}, '（清空后，试题将无法找回）')
      },
      maskClosable: false,
      keyboard: false,
      onOk: () => {
        this.clearAll()
      }
    })
  }
  public async clearAll(item?) {
    let params = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId
    }
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      buttonName: '删除',
      proSource: this.moduleName
    })
    if (this.user && this.user.nickname) {
      if (item && item.sequence && item.sequence.length > 0) {
        for (let n of item.sequence) {
          this.questions.splice(
            this.questions.findIndex((itm) => itm === n),
            1
          )
        }
        params.question_cart.question_ids = this.questions
      }
      let { data } = await updateQuestionCart(params)
      // console.log(msg)
      this.$store.commit('SET_CART', data)
    } else {
      this.$store.commit('SET_LOGINMODAL', true)
    }
  }
}
